import { appraisalFeePricingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const APPRAISAL_FEE_PRICING_ACTION_TYPE = createNamedActions('appraisalFeePricing', {
  GET_APPRAISAL_FEE_PRICINGS: 'GET_APPRAISAL_FEE_PRICINGS',
  CREATE_APPRAISAL_FEE_PRICING: 'CREATE_APPRAISAL_FEE_PRICING',
  UPDATE_APPRAISAL_FEE_PRICING: 'UPDATE_APPRAISAL_FEE_PRICING',
  DELETE_APPRAISAL_FEE_PRICING: 'DELETE_APPRAISAL_FEE_PRICING',
});

const appraisalFeePricingSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getAppraisalFeePricingsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalFeePricingApi.getAppraisalFeePricings(params);

  return dispatch({
    type: APPRAISAL_FEE_PRICING_ACTION_TYPE.GET_APPRAISAL_FEE_PRICINGS,
    payload: normalize(data, [appraisalFeePricingSchema]).entities.data,
  });
});

export const createAppraisalFeePricingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalFeePricingApi.createAppraisalFeePricing(params);

  return dispatch({
    type: APPRAISAL_FEE_PRICING_ACTION_TYPE.CREATE_APPRAISAL_FEE_PRICING,
    payload: data,
  });
});

export const updateAppraisalFeePricingAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await appraisalFeePricingApi.updateAppraisalFeePricing(params);

  return dispatch({
    type: APPRAISAL_FEE_PRICING_ACTION_TYPE.UPDATE_APPRAISAL_FEE_PRICING,
    payload: data,
  });
});

export const deleteAppraisalFeePricingAction = catchAsyncActionError(params => async dispatch => {
  await appraisalFeePricingApi.deleteAppraisalFeePricing(params);

  return dispatch({
    type: APPRAISAL_FEE_PRICING_ACTION_TYPE.DELETE_APPRAISAL_FEE_PRICING,
    meta: params,
  });
});
